var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.9291 10.1005C12.148 9.31946 10.8817 9.31946 10.1007 10.1005C9.31962 10.8816 9.31962 12.1479 10.1007 12.9289L17.1717 20L10.1007 27.0711C9.31962 27.8521 9.31962 29.1184 10.1007 29.8995C10.8817 30.6805 12.148 30.6805 12.9291 29.8995L20.0002 22.8284L27.0712 29.8995C27.8523 30.6805 29.1186 30.6805 29.8997 29.8995C30.6807 29.1184 30.6807 27.8521 29.8997 27.0711L22.8286 20L29.8997 12.9289C30.6807 12.1479 30.6807 10.8816 29.8997 10.1005C29.1186 9.31946 27.8523 9.31946 27.0712 10.1005L20.0002 17.1716L12.9291 10.1005Z","fill":"white"}));
}

Cross.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
